module.exports = __webpack_public_path__ + "static/img/excel.0499f4e0.png";